import React, { useState } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import {
  FiBriefcase,
  FiUsers,
  FiBarChart2,
  FiSearch,
  FiClock,
  FiMenu,
  FiX
} from 'react-icons/fi';
import { authService } from '../../services/auth';
import ThemeToggle from '../../components/ThemeToggle';
import UserMenu from '../../components/UserMenu';
import './Admin.css';

const Admin: React.FC = () => {
  const user = authService.getUser();
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  const closeSidebarOnMobile = () => {
    if (window.innerWidth <= 1024) setSidebarOpen(false);
  };

  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : ''}`}>
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <img
            src="https://digitalsac.io/wp-content/uploads/2024/02/digitalsac2026.png"
            alt="DigitalSac"
            className="admin-logo"
          />
          <div className="admin-sidebar-brand">
            <h2>GetCID</h2>
            <span>Admin Console</span>
          </div>
        </div>

        <nav className="admin-nav">
          <span className="sidebar-section">Gestão</span>
          <NavLink to="/admin/tenants" onClick={closeSidebarOnMobile} className="nav-link">
            <FiBriefcase /> <span>Clientes</span>
          </NavLink>
          <NavLink to="/admin/users" onClick={closeSidebarOnMobile} className="nav-link">
            <FiUsers /> <span>Usuários</span>
          </NavLink>
          <NavLink to="/admin/reports" onClick={closeSidebarOnMobile} className="nav-link">
            <FiBarChart2 /> <span>Relatórios</span>
          </NavLink>

          <span className="sidebar-section">Operações</span>
          <NavLink to="/admin/consultas" onClick={closeSidebarOnMobile} className="nav-link">
            <FiSearch /> <span>Consultas</span>
          </NavLink>
          <NavLink to="/admin/historico" onClick={closeSidebarOnMobile} className="nav-link">
            <FiClock /> <span>Histórico</span>
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          <UserMenu profileBase="/admin" roleLabel={user?.role === 'admin' ? 'Administrador' : 'Usuário'} />
        </div>
      </aside>

      {sidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}

      <main className="admin-main">
        <header className="admin-header">
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen((s) => !s)}
            aria-label="Abrir menu"
          >
            {sidebarOpen ? <FiX /> : <FiMenu />}
          </button>
          <div className="header-title">
            <h1>Painel de Administração</h1>
            <p>
              Olá, <strong>{user?.name || 'Admin'}</strong>{' '}
              <small>({user?.role})</small>
            </p>
          </div>
          <div className="header-actions">
            <ThemeToggle />
          </div>
        </header>

        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Admin;
